import { render, staticRenderFns } from "./sidebar-component.vue?vue&type=template&id=3c922175&scoped=true&"
import script from "./sidebar-component.vue?vue&type=script&lang=js&"
export * from "./sidebar-component.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-component.vue?vue&type=style&index=0&id=3c922175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c922175",
  null
  
)

export default component.exports